import { render } from "./RenameDPSubCategory.vue?vue&type=template&id=22b1aece&scoped=true&ts=true"
import script from "./RenameDPSubCategory.vue?vue&type=script&lang=ts"
export * from "./RenameDPSubCategory.vue?vue&type=script&lang=ts"

import "./RenameDPSubCategory.vue?vue&type=style&index=0&id=22b1aece&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22b1aece"]])

export default __exports__